import React from 'react';
import PropTypes from 'prop-types';
import { Input } from '@spark';
import FieldLabel from '@/features/datasets/components/DataCollection/GenerateDataWithAI/shared/FieldLabel';

export const formatCount = (value) =>
    Number.isFinite(value) ? value.toLocaleString('en-US') : '';

export const parseCount = (text) => {
    const digits = (text || '').replace(/[^0-9]/g, '');
    return digits ? parseInt(digits, 10) : null;
};

/**
 * Comma-formatted integer input for record counts (Figma shows "1,000").
 * `value` is a number or null; `onChange` receives the parsed number or null.
 */
const RecordCountInput = ({ label, required = false, help, value, onChange, danger = false }) => (
    <div className="gdai-field">
        <FieldLabel text={label} required={required} help={help} truncate />
        <Input
            showLabel={false}
            size="medium"
            inputMode="numeric"
            value={formatCount(value)}
            danger={danger}
            onChange={(event) => onChange(parseCount(event.target.value))}
        />
    </div>
);

RecordCountInput.propTypes = {
    label: PropTypes.string.isRequired,
    required: PropTypes.bool,
    help: PropTypes.string,
    value: PropTypes.number,
    onChange: PropTypes.func.isRequired,
    danger: PropTypes.bool,
};

export default RecordCountInput;
